import { CurrentUser } from '@shared/model/current-user';

export const getCurrentUserRole = (user: CurrentUser | null) => {
    if (!user) {
        return null;
    }
    return user.role.code;
};
